import type { FC } from "react";
import { HiOfficeBuilding } from "react-icons/hi";
import { useTranslation } from "react-i18next";

const SelectCompanyPrompt: FC = () => {
    const { t } = useTranslation(["company"]);
    return (
        <div className="flex flex-col items-center justify-center gap-3 py-20 text-center">
            <div className="flex items-center justify-center w-14 h-14 rounded-2xl bg-indigo-50 dark:bg-indigo-900/30">
                <HiOfficeBuilding className="w-7 h-7 text-indigo-500" />
            </div>
            <p className="text-sm font-medium text-gray-500 dark:text-gray-400 max-w-xs">
                {t("selectCompanyPrompt")}
            </p>
        </div>
    );
};

export default SelectCompanyPrompt;
